import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
import { FormLabelRequiredText } from './FormLabelRequiredText';
const Styles = labelStyles('FormLabel', {
    root: css `
    display: grid;
    justify-content: start;
    grid-gap: 5px;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    cursor: pointer;
    color: ${Colors.neutral700};

    &[data-align-items='center'] {
      align-items: center;
    }

    &[data-align-items='start'] {
      align-items: start;
    }

    &[data-justify-content='start'] {
      justify-content: start;
    }

    &[data-justify-content='stretch'] {
      justify-content: stretch;
    }

    &[data-state~='selected'] {
      color: ${Colors.blue};
    }

    &[data-state~='errored'] {
      color: ${Colors.error400};
    }

    &[data-state~='disabled'] {
      cursor: not-allowed;
    }

    &[data-state~='disabled'] {
      color: ${Colors.neutral500};
    }

    &[data-size='small'] {
      ${Typography.smallPrint1Semibold};
    }

    &[data-size='medium'] {
      ${Typography.paragraph3Medium};
    }

    &[data-size='medium'][data-state='selected'] {
      ${Typography.paragraph3Semibold}
    }
  `,
});
export const FormLabel = ({ children, alignItems = 'center', htmlFor = undefined, isDisabled = undefined, isErrored = undefined, isRequired = undefined, isSelected = undefined, justifyContent = 'start', requiredText = undefined, size = 'medium', }) => {
    return (isolateComponent("label", { css: Styles.root, "data-align-items": alignItems, "data-justify-content": justifyContent, "data-size": size, "data-state": [
            isSelected && 'selected',
            isErrored && 'errored',
            isDisabled && 'disabled',
        ]
            .filter(Boolean)
            .join(' ') || undefined, htmlFor: htmlFor },
        isRequired && '*',
        children,
        isRequired ? (requiredText ? (isolateComponent(FormLabelRequiredText, { isDisabled: isDisabled }, requiredText)) : (isolateComponent(FormLabelRequiredText, { isDisabled: isDisabled }))) : null));
};
//# sourceMappingURL=FormLabel.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
